<template functional>
  <div class="flex-row flex__right">
    <!-- <i class="cellIcon color__silver fas fa-user-circle"></i> -->
    {{ props.name || "-" }}
  </div>
</template>
<script>
  import buildShortNameFilter from "../../filters/buildShortNameFilter.js";

  export default {
    name: "display-people",
    props: ["name"],
    filters: {buildShortNameFilter}
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/displayPeople.vue